<template>
  <div>
    <b-form-row>
      <b-form-group label="Título" class="col-6">
        <b-form-input
          v-model="card_link_item.title"
          placeholder="Título do Link"
          :state="validateState('title')"
        />
        <b-form-invalid-feedback>
          Este é um campo obrigatório.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Abrir" class="col-6">
        <b-form-select
          v-model="card_link_item.target"
          :options="optionsTarget"
          :state="validateState('target')"
        />
        <b-form-invalid-feedback>
          Tipo é um campo obrigatório.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="URL" class="col-12">
        <b-form-input
          v-model="card_link_item.url"
          placeholder="URL de redirecionamento"
          :state="validateState('url')"
        />
        <b-form-invalid-feedback>
          Este é um campo obrigatório.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Informações" class="col-12">
        <b-form-input
          v-model="card_link_item.info"
          placeholder="Informações adicionais"
        />
      </b-form-group>
    </b-form-row>
    <div class="row no-gutters justify-content-end pb-4">
      <b-button @click="$emit('cancel')">Cancelar</b-button>
      <b-button variant="bagsis" @click="submitForm">Salvar</b-button>
    </div>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    card_link_item: {
      url: {
        required,
      },
      target: {
        required,
      },
      title: {
        required,
      },
    },
  },
  props: {
    openItem: {
      type: Object,
      default: () => ({
        url: "",
        target: "_blank",
        title: "",
        info: "",
      }),
    },
  },
  data: () => ({
    card_link_item: {
      url: "",
      title: "",
      target: "_blank",
      info: "",
    },
    optionsTarget: [
      { value: "_blank", text: "Nova Página" },
      { value: "_self", text: "Mesma Página" },
    ],
  }),
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.card_link_item[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.card_link_item.$touch();
      return !this.$v.card_link_item.$anyError;
    },
    submitForm() {
      if (this.isValid()) {
        this.$emit("save", this.card_link_item);
      }
    },
    setCardLinkItem(card_link_item) {
      this.card_link_item = card_link_item;
    },
  },
};
</script>
